export class InvalidAnnotationsError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = "InvalidAnnotationsError";
  }
}
